function changeHowToPlayPcode(e: React.MouseEvent): void {
	const mainClass = this;

	const pcode = e.currentTarget.getAttribute("game");

	mainClass.setState({
		showHowToPlayDropdown: false,
		howToPlayPcode: pcode
	});
}


function toggleHowToPlay(e: React.MouseEvent): void {
	let pcode = this.activePcode;

	if (e)
		pcode = e.currentTarget.getAttribute("game");

	if ("showSidebar" in this.state)
		this.setState({ showSidebar: false });

	this.setState({
		showHowToPlay: !this.state.showHowToPlay,
		showBurgerMenu: false,
		howToPlayPcode: pcode
	}, () => {
		//Prevents crashing on desktop
		if (this.updateStreamClass)
			this.updateStreamClass(); //toggleHowToPlay
	});
}

function toggleHowToPlayDropdown(): void {
	this.setState({
		showHowToPlayDropdown: !this.state.showHowToPlayDropdown
	});
}

export {
	changeHowToPlayPcode,
	toggleHowToPlay,
	toggleHowToPlayDropdown
}